import { Route, Routes } from "react-router-dom";

import HistoryPage from "./Overview";
import HistorySessionDetail from "./SessionDetail";
import HistoryTutoringDetail from "./TutoringDetail";

const HistoryRoutes = () => (
  <Routes>
    <Route index element={<HistoryPage />} />
    <Route path="/doucovani/:tutoringId/:userAssignmentId" element={<HistoryTutoringDetail />} />
    <Route path="/cviceni/:sessionId/:userAssignmentId" element={<HistorySessionDetail />} />
  </Routes>
);

export default HistoryRoutes;
